import React, { useEffect, useState } from "react";
import FormikController from "../../../components/FormikController/FormikController";
import { nurseVisitType } from "../../../Constants/Constants";
import {
  FormControlLabel,
  Grid,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import ConfirmPopUp from "../../../components/ConfirmPopUp/ConfirmPopUp";
import { headerTextStyles } from "../../../Constants/Styles";
import { competencyCheckList } from "../../../Constants/FileData";
import ClientStore from "../../../Store/ClientStore";
import { useFormik } from "formik";
import { YupValidation } from "../../../Constants/ValidationConstants";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import { nurseCGRelation } from "../../../Utils/PdfFileUtils";
import AgencyStore from "../../../Store/AgencyStore";
import { ClientURL } from "../../../Url/Url";
import axios from "axios";
const AddCompetencyCheckList = ({ handleClose, type, editData }) => {
  const cgCompetencyCheckList =
    type == "save" ? competencyCheckList : editData?.personalCareAidEvalList;
  const [tasks, setTasks] = useState(cgCompetencyCheckList);
  const [saveUpadateState, setSaveUpadateState] = useState("");
  const { clientId } = useParams();
  const handlesaveUpadateState = (value) => {
    setSaveUpadateState(value);
  };

  const handleChange = (id, type, value, field) => {
    setTasks((prevTasks) =>
      prevTasks.map((item, index) => {
        if (index === id) {
          if (type === "radio") {
            return {
              ...item,
              subject: item.subject,
              satisfactory: value,
              ratingList: item.ratingList,
            };
          } else if (type === "text") {
            return {
              ...item,
              comment: field == "comment" ? value : item.comment,
              evaluatedArea:
                field == "evaluatedArea" ? value : item.evaluatedArea,
            };
          }
        }
        return item;
      })
    );
  };

  const formik = useFormik({
    initialValues: {
      relationRN: "",
      relationCg: "",
      visitType: "",
    },
    validationSchema: Yup.object({
      relationRN: YupValidation.requiredOnly,
      relationCg: YupValidation.requiredOnly,
      visitType: YupValidation.requiredOnly,
    }),

    onSubmit: (values) => {
      if (saveUpadateState == "save") {
        saveCompetencyCheckList(values);
      } else updateCompetencyCheckList(values);
    },
  });

  const [relationRN, setRelationRN] = useState([]);
  const [relationCg, setRelationCg] = useState([]);
  const [rnFullName, setRnFullName] = useState("");
  const [careGiverName, setCareGiverName] = useState("");
  useEffect(() => {
    const [nurseData, careGiverData] = nurseCGRelation();
    setRelationRN(nurseData);
    setRelationCg(careGiverData);
    if (type == "update") {
      setProfileDataFormik();
      setRnFullName(editData?.rnName);
      setCareGiverName(editData?.caregiverName);
    }
  }, []);

  const setProfileDataFormik = () => {
    formik.setValues({
      visitType: editData?.visitType || "",
      relationCg: editData?.caregiverId || "",
      relationRN: editData?.rnId || "",
    });
  };

  const saveCompetencyCheckList = (values) => {
    AgencyStore.setIsLoading(true);
    const params = {
      clientId: clientId,
      rnId: values.relationRN,
      visitType: values.visitType,
      caregiverId: values.relationCg,
      personalCareAidEvalList: tasks,
    };
    axios
      .post(ClientURL.SAVE_COMPETENCY_CHECKLIST, params, {
        headers: { Authorization: localStorage.getItem("loginToken") },
      })
      .then((res) => {
        if (res?.data?.status == "success") {
          AgencyStore.showAlert(
            "success",
            "Successfully Saved Competency CheckList Records"
          );

          ClientStore.setCompetencyCheckListRecord(res?.data?.result);
          AgencyStore.setIsLoading(false);
          AgencyStore.setIsSaveLoading(true);
          handleClose();
        } else if (res?.data?.status == "failed") {
          AgencyStore.setIsLoading(false);
          AgencyStore.showAlert("error", res?.data?.message);
        } else {
          AgencyStore.setIsLoading(false);
          AgencyStore.showAlert(
            "error",
            "Failed to Saved Competency CheckList Records"
          );
        }
      })
      .catch((err) => {
        AgencyStore.setIsLoading(false);
        AgencyStore.showAlert(
          "error",
          "Failed to Saved CareGiver Evaluation Records"
        );
      });
  };

  const updateCompetencyCheckList = (values) => {
    AgencyStore.setIsLoading(true);
    const params = {
      id: editData?.id,
      clientId: clientId,
      rnId: values.relationRN,
      visitType: values.visitType,
      caregiverId: values.relationCg,
      personalCareAidEvalList: tasks,
    };
    axios
      .post(ClientURL.UPDATE_COMPETENCY_CHECKLIST, params, {
        headers: { Authorization: localStorage.getItem("loginToken") },
      })
      .then((res) => {
        if (res?.data?.status == "success") {
          AgencyStore.showAlert(
            "success",
            "Successfully Update Competency CheckList"
          );
          AgencyStore.setIsLoading(false);
          AgencyStore.setIsSaveLoading(true);
          handleClose();
        } else if (res?.data?.status == "failed") {
          AgencyStore.setIsLoading(false);
          AgencyStore.showAlert("error", res?.data?.message);
        } else {
          AgencyStore.setIsLoading(false);
          AgencyStore.showAlert(
            "error",
            "Failed to Update Competency CheckList"
          );
        }
      })
      .catch((err) => {
        AgencyStore.setIsLoading(false);
        AgencyStore.showAlert("error", "Failed to Update Competency CheckList");
      });
  };
  return (
    <>
      <div className="homeSafetyContainer">
        <div className="underlineClick" onClick={handleClose}>
          Back
        </div>
        <div className="safetySelectInput">
          <div>Visit Type:</div>
          <div className="clientListinputFiled">
            <FormikController
              control="selects"
              error
              selectitem={nurseVisitType}
              {...formik.getFieldProps("visitType")}
              touch={formik.touched.visitType}
              errorname={formik.errors.visitType}
            />
          </div>
        </div>
      </div>

      <div className="medicationWrapper">
        <div className="medicationSection">
          <div className="heading">
            {type == "save"
              ? "COMPETENCY CHECKLIST PERSONAL CARE AIDE"
              : " Update COMPETENCY CHECKLIST PERSONAL CARE AIDE"}
          </div>
          <h4>
            NOTE: Due to Covid-19 outbreak, and following the Governor Hogan’s
            suggestion, this assessment was completed remotely via telephone
            call.
          </h4>

          <div className="detailWrapper">
            <Grid container spacing={2}>
              <Grid item xs={6} className="rowSection">
                <div className="nameList">Client's Name:</div>
                <div className="medicationForm">
                  <FormikController
                    value={
                      ClientStore.ClientAllData.client?.firstName +
                      "  " +
                      ClientStore.ClientAllData.client?.lastName
                    }
                    variant="standard"
                    control="textfield"
                  />
                </div>
              </Grid>
              <Grid item xs={6} className="rowSection">
                <div className="nameList">RN Name:</div>
                <div className="medicationForm">
                  <FormikController
                    control="selectByInput"
                    options={relationRN}
                    handleChange={(event, value) => {
                      formik.setFieldValue(
                        "relationRN",
                        value ? value.value : ""
                      );
                      setRnFullName(value.label);
                    }}
                    values={rnFullName}
                    touch={formik.touched.relationRN}
                    errorname={formik.errors.relationRN}
                  />
                </div>
              </Grid>

              <Grid item xs={8} className="rowSection">
                <div className="nameDesc">Caregiver's Name:</div>
                <div className="medicationForm">
                  <FormikController
                    control="selectByInput"
                    options={relationCg}
                    handleChange={(event, value) => {
                      formik.setFieldValue(
                        "relationCg",
                        value ? value.value : ""
                      );
                      setCareGiverName(value.label);
                    }}
                    values={careGiverName}
                    touch={formik.touched.relationCg}
                    errorname={formik.errors.relationCg}
                  />
                </div>
              </Grid>
            </Grid>
          </div>

          <TableContainer>
            <Table className="table" size="small">
              <TableHead>
                <TableRow>
                  <TableCell className="tablecell" sx={headerTextStyles}>
                    Evaluate the Personal Care Aide in each of the following
                    subject areas.
                  </TableCell>
                  <TableCell className="tablecell" sx={headerTextStyles}>
                    Have evaluated this area (initial here)
                  </TableCell>

                  <TableCell className="tablecell" sx={headerTextStyles}>
                    Satisfactory
                  </TableCell>
                  <TableCell className="tablecell" sx={headerTextStyles}>
                    Unsatisfactory
                  </TableCell>

                  <TableCell className="tablecell" sx={headerTextStyles}>
                    For any area evaluated as unsatisfactory, reevaluate the PCA
                    and indicate date below when a satisfactory rating is
                    achieved.
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {tasks.map((item, index) => {
                  return (
                    <TableRow key={index}>
                      <TableCell className="tablecell">
                        {index + 1} {"."}
                        {item.subject}
                      </TableCell>
                      <TableCell className="tablecell">
                        <FormikController
                          control="textfield"
                          variant="standard"
                          value={item.evaluatedArea}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          onChange={(e) =>
                            handleChange(
                              index,
                              "text",
                              e.target.value,
                              "evaluatedArea"
                            )
                          }
                        />
                      </TableCell>
                      <TableCell className="tablecell">
                        <FormControlLabel
                          control={
                            <Radio
                              value="Yes"
                              checked={item.satisfactory}
                              onChange={() => {
                                handleChange(
                                  index,
                                  "radio",
                                  true,
                                  "satisfactory"
                                );
                              }}
                            />
                          }
                        />
                        <div>{item.ratingList}</div>
                      </TableCell>
                      <TableCell className="tablecell">
                        <FormControlLabel
                          control={
                            <Radio
                              checked={!item.satisfactory}
                              value="No"
                              onChange={() => {
                                handleChange(
                                  index,
                                  "radio",
                                  false,
                                  "satisfactory"
                                );
                              }}
                            />
                          }
                        />
                      </TableCell>
                      <TableCell className="tablecell">
                        <FormikController
                          control="textfield"
                          variant="standard"
                          value={item.comment}
                          InputProps={{
                            disableUnderline: true,
                          }}
                          onChange={(e) =>
                            handleChange(
                              index,
                              "text",
                              e.target.value,
                              "comment"
                            )
                          }
                        />
                      </TableCell>
                    </TableRow>
                  );
                })}
              </TableBody>
            </Table>
          </TableContainer>
          <span>
            NOTE: Passing is defined as having no more than one unsatisfactory
            rating. If a PCA passes with one unsatisfactory rating, he or she
            must not perform any skill or activity in that area without direct
            supervision until after he or she received training in that area and
            achieves a satisfactory rating in that area. Skills competency is
            evaluated by observing the PCA with client before the aide may make
            independent home visits.
          </span>

          <Grid container spacing={2}>
            <div className="formButtonSave">
              <ConfirmPopUp
                buttonLabel={type == "save" ? "Save " : "Update"}
                title={type == "save" ? "Save " : "Update"}
                content=" Please confirm your decision below."
                onConfirm={() => {
                  if (type == "save") {
                    handlesaveUpadateState("save");
                  } else {
                    handlesaveUpadateState("update");
                  }
                  formik.handleSubmit();
                }}
                clickHTML={
                  <FormikController
                    control="buttons"
                    name={
                      type == "save"
                        ? "SAVE COMPETENCY CHECKLIST PERSONAL CARE AIDE"
                        : "UPDATE COMPETENCY CHECKLIST PERSONAL CARE AIDE"
                    }
                    className="buttonSelectedGreen fixedWidth"
                    fullWidth="false"
                  />
                }
              />
            </div>
          </Grid>
        </div>
      </div>
    </>
  );
};

export default AddCompetencyCheckList;
